@if (epfDate != undefined) {
  <app-add-loan-details (getLoanData)="getLoan1Data($event)" [availableReserve]="selectedProfile.Reserve" [isEPF]="isEPF" [epfDate]="getFormValue('epfDate')" [isEPFExtra]="isEPFExtra" [previousPrincipal]="previousPrincipal" [epfAmount]="epfAmount" [isManualKeyIn]="isManualKeyIn" required> </app-add-loan-details>
}

@if (loan != undefined && loan.Principal != undefined && loan.Principal != 0) {
  <h3 class="mt-2" style="font-weight: bold; color: brown; background-color: yellow">
    Total On Hand: RM
    {{ calculateTotalOnHand() || 0 }}
  </h3>
}
